"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetailContainer = void 0;
const react_1 = __importStar(require("react"));
const Box_1 = __importDefault(require("@material-ui/core/Box"));
const form_custom_field_1 = require("../form/fields/form-custom-field");
const form_panel_1 = require("../form/fields/form-panel");
const form_context_1 = require("../form/form-context");
const detail_context_1 = require("./detail-context");
function DetailContainer({ children }) {
    const { errors } = (0, react_1.useContext)(form_context_1.FormContext);
    const { showErrorPanel } = (0, react_1.useContext)(detail_context_1.DetailContext);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        showErrorPanel && errors.length > 0 && (react_1.default.createElement(form_panel_1.FormPanel, { label: react_1.default.createElement(Box_1.default, { color: "#CD5360", fontWeight: "500" }, "Kontrola spr\u00E1vnosti \u00FAdaj\u016F") }, errors.map((error, i) => (react_1.default.createElement(form_custom_field_1.FormCustomField, { key: i, label: error.label },
            react_1.default.createElement(Box_1.default, { color: "#CD5360", fontWeight: "500" }, error.value)))))),
        children));
}
exports.DetailContainer = DetailContainer;
//# sourceMappingURL=detail-container.js.map